class MiniCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-notification').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('minicart-remove-button', MiniCartRemoveButton);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.cartOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener('change', this.cartOnChange.bind(this));
  }
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }
  updateQuantity(line, quantity, name) {
   

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.renderContents(parsedState);
      }).catch(() => {
       
      });
  }
  open() {
    
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {

    //this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    if (this.header) this.header.reveal();
    var status =  document.getElementById("cart_shop_now");
    if(status){
      document.getElementById("cart-slider").classList.remove("hidden");
      document.getElementById("cart-notification-form").classList.add("hidden");
    }else{
      document.getElementById("cart-slider").classList.add("hidden");
      document.getElementById("cart-notification-form").classList.remove("hidden");
    }
    this.open();
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product'
      },
      {
        id: 'cart-total-price'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-item-count'
      },
      {
        id: 'cart-nofification-bottom'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  
  
  
}

customElements.define('cart-notification', CartNotification);

const cartselectors = {
	container: '[js-cart-products="container"]'
}

document.addEventListener('DOMContentLoaded', () => {
	const cart_node_selectors = {
		container: document.querySelector(cartselectors.container),
	}

	function initSlider() {
		if (!cart_node_selectors.container) { return; }
		const swiper = new Swiper(cartselectors.container, {
			loop: true,
			slidesPerView: 2.5,
			spaceBetween: 10,
      centeredSlides: true,
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next1',
				prevEl: '.swiper-button-prev1',
			},
			breakpoints: {
				768: {
					slidesPerView: 2.5,
					spaceBetween: 10,
				}
			}
		});
	}

	initSlider();
});

